import React from 'react'
import { Tabs } from '@/shared/ui'
import { REWARDS_EXCHANGES, type RewardsExchange } from '../../types'

const EXCHANGE_LABELS: Record<RewardsExchange, string> = {
  bingx: 'BingX',
  bybit: 'Bybit',
  bitget: 'Bitget',
}

export default function RewardsMasterExchangeTabs({
  value,
  onChange,
}: {
  value: RewardsExchange
  onChange: (next: RewardsExchange) => void
}) {
  return (
    <Tabs
      tabs={REWARDS_EXCHANGES.map((ex) => ({ value: ex, label: EXCHANGE_LABELS[ex] || ex.toUpperCase() }))}
      value={value}
      onValueChange={(v) => onChange(v as RewardsExchange)}
    />
  )
}
